const USERNAME_PATTERN = /^[a-z0-9._-]+$/;

// ตรวจและ normalize ค่า Login ก่อนเรียก API โดยคง Password ตามที่ผู้ใช้กรอกทุกตัวอักษร
export const validateUsernameLogin = ({ username, password } = {}) => {
  const normalizedUsername =
    typeof username === "string" ? username.trim().toLowerCase() : "";
  const passwordValue = typeof password === "string" ? password : "";
  const errors = {};

  if (!normalizedUsername) {
    errors.username = "กรุณากรอกชื่อผู้ใช้";
  } else if (
    normalizedUsername.length < 3 ||
    normalizedUsername.length > 64 ||
    !USERNAME_PATTERN.test(normalizedUsername)
  ) {
    errors.username =
      "ชื่อผู้ใช้ต้องมี 3-64 ตัว และใช้ได้เฉพาะ a-z, 0-9, จุด, ขีดกลาง และขีดล่าง";
  }

  if (!passwordValue) {
    errors.password = "กรุณากรอกรหัสผ่าน";
  } else if (passwordValue.length < 12 || passwordValue.length > 128) {
    errors.password = "รหัสผ่านต้องมี 12-128 ตัว";
  }

  return {
    username: normalizedUsername,
    password: passwordValue,
    errors,
  };
};

// แปลง HTTP status เป็นข้อความกลางโดยไม่ใช้รายละเอียด error จาก backend มาแสดงตรง ๆ
export const getLoginErrorMessage = (error) => {
  const status = error?.response?.status;
  if (status === 401) return "ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง";
  if (status === 423) return "บัญชีนี้ไม่พร้อมใช้งาน";
  if (status === 429) {
    return "เข้าสู่ระบบไม่สำเร็จหลายครั้ง กรุณาลองใหม่ภายหลัง";
  }
  return "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง";
};
